import { IStepComponentProps } from "@shared/components/form/types";
import { View } from "react-native";
import { Head } from "@shared/components/head";
import { Text } from "@shared/components/text";
import { dynamicTranslations } from "@shared/utils/dynamicTranslation";
import { ActivityName } from "app/_modules/core/types";
import { useAuth } from "app/auth/hooks/useAuth";

export interface IDrugIntakeInfoStepContext {
  activityName: ActivityName
}

export const DrugIntakeInfoStep = ({ context }: IStepComponentProps<{ administered: boolean }, IDrugIntakeInfoStepContext>) => {
  const { t } = dynamicTranslations();
  const { meData } = useAuth()

  const drug = meData?.current_pathway.drugs.find((drug) => {
    return drug.drug.name === context?.activityName || drug.drug.label === context?.activityName
  })

  const drugDisplayName = drug?.drug.label || t(context?.activityName || '');

  return (
    <View className="flex-col gap-4">
      <Head type="h2">{t("drugs.reminder.titleWithName", { name: drugDisplayName })}</Head>
      <Text className="text-gray-500">{t("drugs.reminder.subtitle")}</Text>
      <View className="p-4 border border-gray-300 rounded-lg">
        <View className="flex-col gap-4">
          <View className="flex-col gap-2">
            <Text className="font-semibold text-gray-500">{t("drugs.reminder.doseLabel")}</Text>
            <Text className="font-semibold">{drug?.drug.dosage}</Text>
          </View>
          {drug?.note && (
            <View className="flex-col gap-2">
              <Text className="font-semibold text-gray-500">{t("drugs.reminder.doctorNotesLabel")}</Text>
              <Text className="font-semibold">{drug.note}</Text>
            </View>
          )}
        </View>
      </View>
    </View>
  )
}
